import { RealtyMapScreenContent } from "../../features/realtyList";

// RealtyMapScreen — route landing for /map.
// Thin composition wrapper around the feature widget. No selectors,
// no dispatch, no state — all owned by the widget.
//
// Substrate: canonical .search-section.search-section--map #Csection
// envelope from modernize.css (see design/map.html lines 149-378). The
// .search-results.map-results positioning context lives INSIDE the
// feature widget; this wrapper is purely the page-level section
// envelope + #Csection skip-link anchor.
//
// The --map modifier flips the section to flex-column + overflow-hidden
// + 10px padding so the inner .map-canvas-wrap can size off the cell
// (modernize.css:7064-7070). The /search variant deliberately omits it.

function RealtyMapScreen() {
  return (
    <section
      className="search-section search-section--map"
      id="Csection"
      tabIndex="-1"
    >
      <RealtyMapScreenContent />
    </section>
  );
}

export default RealtyMapScreen;
